import { render, staticRenderFns } from "./PropertyDisclosures.vue?vue&type=template&id=83f57854&scoped=true&"
import script from "./PropertyDisclosures.vue?vue&type=script&lang=js&"
export * from "./PropertyDisclosures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f57854",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VAlert,VCard})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83f57854')) {
      api.createRecord('83f57854', component.options)
    } else {
      api.reload('83f57854', component.options)
    }
    module.hot.accept("./PropertyDisclosures.vue?vue&type=template&id=83f57854&scoped=true&", function () {
      api.rerender('83f57854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/components/Application/Setup/PropertyDisclosures.vue"
export default component.exports